import { Ownership } from '../PastContactsTypes';

export const pastContactsResultsPerPage = [15, 25, 50, 100];

export const CHANNEL_OPTIONS = [
  {
    value: 'All',
    translationId: 'cs_perfportal_all',
    defaultMessage: 'All',
  },
  {
    value: 'Chat',
    translationId: 'cs_perfportal_chat',
    defaultMessage: 'Chat',
  },
  {
    value: 'Phone',
    translationId: 'cs_perfportal_phone',
    defaultMessage: 'Phone',
  },
  {
    value: 'Email',
    translationId: 'cs_perfportal_referral_email',
    defaultMessage: 'Email',
  },
];

export const TIME_OF_DAY_OPTIONS: {
  [key: number]: {
    label: string;
    value: number;
    lowerBound: string;
    upperBound: string;
    translationId: string;
    defaultMessage: string;
  };
} = {
  0: {
    label: 'All',
    value: 0,
    lowerBound: '',
    upperBound: '',
    translationId: 'cs_perfportal_all',
    defaultMessage: 'All',
  },
  1: {
    label: '6:00 AM to 12:00 PM',
    value: 1,
    lowerBound: '06:00:00',
    upperBound: '12:00:00',
    translationId: 'cs_perfportal_past_contacts_filters_time_6am_12pm',
    defaultMessage: '6:00 AM to 12:00 PM',
  },
  2: {
    label: '12:00 PM to 6:00 PM',
    value: 2,
    lowerBound: '12:00:00',
    upperBound: '18:00:00',
    translationId: 'cs_perfportal_past_contacts_filters_time_12pm_6pm',
    defaultMessage: '12:00 PM to 6:00 PM',
  },
  3: {
    label: '6:00 PM to 12:00 AM',
    value: 3,
    lowerBound: '18:00:00',
    upperBound: '00:00:00',
    translationId: 'cs_perfportal_past_contacts_filters_time_6pm_12am',
    defaultMessage: '6:00 PM to 12:00 AM',
  },
  4: {
    label: '12:00 AM to 6:00 AM',
    value: 4,
    lowerBound: '00:00:00',
    upperBound: '06:00:00',
    translationId: 'cs_perfportal_past_contacts_filters_time_12am_6am',
    defaultMessage: '12:00 AM to 6:00 AM',
  },
};

export const DURATION_OPTIONS: {
  [key: number]: {
    label: string;
    value: number;
    lowerBound: number;
    upperBound: number;
    translationId: string;
    defaultMessage: string;
  };
} = {
  0: {
    label: 'All',
    value: 0,
    lowerBound: 0,
    upperBound: 0,
    translationId: 'cs_perfportal_all',
    defaultMessage: 'All',
  },
  1: {
    label: '1 minute or less',
    value: 1,
    lowerBound: 0,
    upperBound: 60,
    translationId: 'cs_perfportal_past_contacts_filters_duration_1min_or_less',
    defaultMessage: '1 minute or less',
  },
  2: {
    label: '1 to 2 minutes',
    value: 2,
    lowerBound: 60,
    upperBound: 120,
    translationId:
      'cs_perfportal_past_contacts_filters_duration_1_to_2_minutes',
    defaultMessage: '1 to 2 minutes',
  },
  3: {
    label: '2 to 5 minutes',
    value: 3,
    lowerBound: 120,
    upperBound: 300,
    translationId:
      'cs_perfportal_past_contacts_filters_duration_2_to_5_minutes',
    defaultMessage: '2 to 5 minutes',
  },
  4: {
    label: '5 minutes or more',
    value: 4,
    lowerBound: 300,
    upperBound: 2147483647,
    translationId: 'cs_perfportal_past_contacts_filters_duration_5min_or_more',
    defaultMessage: '5 minutes or more',
  },
};

export const OWNERSHIP_OPTIONS = [
  {
    value: Ownership.ALL,
    translationId: 'cs_perfportal_all',
    defaultMessage: 'All',
  },
  {
    value: Ownership.MARKED_SPAM,
    translationId: 'cs_perfportal_ownership_marked_spam',
    defaultMessage: 'Marked Spam',
  },
  {
    value: Ownership.MARKED_DUPLICATE,
    translationId: 'cs_perfportal_ownership_marked_duplicate',
    defaultMessage: 'Marked Duplicate',
  },
  {
    value: Ownership.CONSULTED,
    translationId: 'cs_perfportal_ownership_consulted',
    defaultMessage: 'Consulted',
  },
  {
    value: Ownership.TRANSFERED,
    translationId: 'cs_perfportal_ownership_transferred',
    defaultMessage: 'Transferred',
  },
  {
    value: Ownership.CHAT_DROPPED,
    translationId: 'cs_perfportal_ownership_chat_dropped',
    defaultMessage: 'Chat Dropped',
  },
  {
    value: Ownership.PARKED,
    translationId: 'cs_perfportal_ownership_parked',
    defaultMessage: 'Parked',
  },
  {
    value: Ownership.RESOLVED,
    translationId: 'cs_perfportal_ownership_resolved',
    defaultMessage: 'Resolved',
  },
  {
    value: Ownership.UNKNOWN,
    translationId: 'cs_perfportal_ownership_unknown',
    defaultMessage: 'Unknown',
  },
];
